export const IS_THIS_IT_SUGGESTION_TEXT = (attribute?: string) =>
  `You said you ${attribute}. We can help with that.`;
export const IS_THIS_IT_RESULT_DESCRIPTION = `Try this free challenge and take the first step toward your next step.`;
export const IS_THIS_IT_GO_TO_APP_BUTTON_TEXT = 'Go To App';
export const IS_THIS_IT_CHANGE_EMAIL_BUTTON_TEXT = 'Change Email';
